import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import BootStrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueToasted from 'vue-toasted';
import { Auth0Plugin } from './auth/authPlugin';
import { AxiosBlockbusterPlugin, AxiosSurelockPlugin } from './plugins/axios';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSquare, faFileAlt, faEdit, faFlag as farFlag } from '@fortawesome/free-regular-svg-icons'
import {
  faChevronDown,
  faChevronUp,
  faChevronRight,
  faChevronLeft,
  faCheckSquare,
  faCopy,
  faDownload,
  faEye,
  faEyeSlash,
  faTimes,
  faLock,
  faFlag as fasFlag,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons'

library.add({
  faChevronDown,
  faChevronUp,
  faChevronRight,
  faChevronLeft,
  faCopy,
  faSquare,
  faCheckSquare,
  faDownload,
  faEye,
  faEyeSlash,
  faLock,
  farFlag,
  fasFlag,
  faFileAlt,
  faEdit,
  faTimes,
  faEnvelope,
});

Vue.use(BootStrapVue);
Vue.use(VueToasted);

Vue.config.productionTip = false;
Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH_DOMAIN,
  clientId: process.env.VUE_APP_PORTAL_CLIENT_ID,
  onRedirectCallback: (appState?: any) => {
    const targetUrl = appState && appState.targetUrl ? appState.targetUrl : window.location.pathname;

    if (router.currentRoute.path !== targetUrl) {
      router.push(targetUrl);
    }
  },
});

Vue.use(AxiosBlockbusterPlugin);
Vue.use(AxiosSurelockPlugin);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
